import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=7977dd0d&scoped=true"
import script from "./Top.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top.vue?vue&type=style&index=0&id=7977dd0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977dd0d",
  null
  
)

export default component.exports